import React__default from 'react';
import PropTypes from 'prop-types';
import { I as Icon } from './index-11bc5ac3.js';
import './_commonjsHelpers-17042db9.js';

function Location(props) {
  var location = props.location,
    hideIcon = props.hideIcon,
    showAsLink = props.showAsLink;
  var address = location.address,
    city = location.city,
    region = location.region,
    country = location.country;
  return /*#__PURE__*/React__default.createElement("span", {
    className: "bf-location-main-wrapper"
  }, !hideIcon && /*#__PURE__*/React__default.createElement("span", {
    className: "bf-location-icon-wrapper ".concat(showAsLink ? 'bf-text-link' : '')
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: "bf-icon-map-marker"
  })), /*#__PURE__*/React__default.createElement("span", {
    className: "bf-location-info-wrapper ".concat(showAsLink ? 'bf-text-link' : '')
  }, address ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    className: "bf-location-info-address"
  }, address), city || region || country ? /*#__PURE__*/React__default.createElement("span", null, ",\xA0") : null) : null, city ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    className: "bf-location-info-city"
  }, city), region || country ? /*#__PURE__*/React__default.createElement("span", null, ",\xA0") : null) : null, region ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    className: "bf-location-info-region"
  }, region), country ? /*#__PURE__*/React__default.createElement("span", null, ",\xA0") : null) : null, country ? /*#__PURE__*/React__default.createElement("span", {
    className: "bf-location-info-country"
  }, country) : null));
}
Location.defaultProps = {
  hideIcon: false,
  showAsLink: false
};
Location.propTypes = {
  /**
  Location params (address, city, region, country)
   */
  location: PropTypes.shape({
    address: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    city: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    region: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    country: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
  }).isRequired,
  /**
  Show Location without map marker icon
   */
  hideIcon: PropTypes.bool,
  /**
  Show Location as a look like link
   */
  showAsLink: PropTypes.bool
};

export default Location;
//# sourceMappingURL=Location.js.map
